import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


const init = () => {
	fadeLeft();
	fade();
}

/**
 * Fade Left
 *
 * @class 'js-animation-fade-left'
 */
const fadeLeft = () => {


	gsap.utils.toArray('.js-animation-wrapper').forEach((wrapper) => {
		wrapper.querySelectorAll('.js-animation-fade-left').forEach((elem, index) => {
			let mql = window.matchMedia("(min-width: 781px)");

			gsap.fromTo(
				elem,
				{
					x: 200,
					autoAlpha: 0
				},
				{
					x: 0,
					autoAlpha: 1,
					stagger: () => {
						if ( mql.matches ) {
							return 0.20;
						}
						return 0;
					},
					delay: () => {
						if ( mql.matches ) {
							return 0.1 * index;
						}
						return 0;
					},
					scrollTrigger: {
						trigger: elem,
						start: "top 75%",
					}
				}
			)
		})
	});

}

/**
 * Fade
 *
 * Fades in content
 */
const fade = () => {
	gsap.utils.toArray('.js-animation-fade').forEach(elem => {
		gsap.fromTo(
			elem,
			{
				autoAlpha: 0
			}, {
				autoAlpha: 1,
				scrollTrigger: {
					trigger: elem,
					start: "top 75%"
				}
			}
		)
	})
}

window.addEventListener('DOMContentLoaded', () => {
	init();
})